export { default } from './InformationPremiumPlus';
